import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  appBar: {
    backgroundColor: theme.palette.secondary.light,
    boxShadow: "none !important",
    color: "black",
    zIndex: `${theme.zIndex.drawer + 1} !important`,
    height: "68px",
    [theme.breakpoints.down(1001)]: {
      height: "44px",
    },
  },
  toolBar: {
    padding: "10px 22px",
    minHeight: "auto",
    maxHeight: "68px",
    "& .MuiBox-root": {
      margin: 0,
    },
    [theme.breakpoints.down(1201)]: {
      padding: "10px 12px",
    },
    [theme.breakpoints.down(1001)]: {
      maxHeight: "44px",
    },
  },
  grow: {
    flexGrow: 1,
  },
  tester: {
    backgroundColor: (props) => {
      return "red";
    },
  },
  title: {
    display: "block",
  },
}));

export default useStyles;
